import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { StorageUtils } from '../../../../utils/storage-utils';
import { PartnerService } from '../../../ok-company/partner/partner-service';
import { CompanyService } from '../../../ok-company/company/company-service';
import swal from 'sweetalert2';
import { ProcessService } from 'app/pages/process/process/process-service';
import { Company } from '../../company/company';
import { RegisterDocumentPageComponent } from '../register-document/register-document-page.component';
import { DocumentFileSearch } from '../../document-file/document-file-search';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentFileService } from '../../document-file/document-file-service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SelectionType } from '@swimlane/ngx-datatable';
import { UserBService } from 'app/pages/ok-admin/user-b/user-b-service';
import { Process } from 'app/pages/process/process/process';
import { DocumentFile } from '../../document-file/document-file';

declare var require: any;
const deps: any = require('../../../../shared/data/document-dep-types.json');

const types: any = require('../../../../shared/data/document-file-types.json');

@Component({
    selector: 'onboardCheckList-component-page',
    templateUrl: './OnBoardCheckList.component.html',
    styleUrls: ['./OnBoardCheckList.component.scss', '../../../../../assets/sass/libs/select.scss', '../../../../../assets/sass/libs/datatables.scss'],
    providers: [
        ProcessService,
        StorageUtils,
        PartnerService,
        CompanyService
    ],
    encapsulation: ViewEncapsulation.None
})
export class OnBoardCheckListPageComponent implements OnInit {
    @Input()
    company: Company;

    @Input()
    type: string;

    @Input()
    receivedWindow: boolean;

    @Input()
    process: Process

    scrollBarHorizontal = (window.innerWidth < 1200);

    rows = {};

    rowsPage = [];
    selectionType = SelectionType;

    page = {
        size: 10,
        totalElements: 0,
        totalPages: 0,
        pageNumber: 1
    }

    currYear = new Date().getFullYear()
    lastYear = new Date().getFullYear() - 1

    competences = [
        '12/' + this.lastYear,
        '01/' + this.currYear,
        '02/' + this.currYear,
        '03/' + this.currYear,
        '04/' + this.currYear,
        '05/' + this.currYear,
        '06/' + this.currYear,
        '07/' + this.currYear,
        '08/' + this.currYear,
        '09/' + this.currYear,
        '10/' + this.currYear,
        '11/' + this.currYear,
        '12/' + this.currYear
    ]

    search: DocumentFileSearch;

    reorderable = false;

    types = []

    listDeps: any

    selectedCompetence: string;
    selDep = {}

    constructor(private router: Router,
        private route: ActivatedRoute,
        private documentFileService: DocumentFileService,
        private cdRef: ChangeDetectorRef,
        private userB: UserBService,
        private modalService: NgbModal,
        public storageUtils: StorageUtils) {

        this.search = new DocumentFileSearch();
    }

    ngOnInit() {
        if (this.process != null && this.process != undefined && this.storageUtils.getLoggedUser().type.includes('CONTAZZ')) {
            this.selectTable()
        }
        else if (this.process?.info.typeAccount === 'MIGRATION' || this.process?.info.typeAccount === 'OPEN_COMPANY') {
            this.listDeps = deps[this.type]
            this.loadDefautDocument()
        }
        else if (this.storageUtils.getLoggedUser().type == 'CUSTOMER') {
            this.listDeps = deps[this.type]
            this.loadDefautDocument()
        }
    }

    loadDefautDocument() {
        const requiredDocuments = [
            "Ficha de Sócios com retirada de pró-labore",
            "Última SEFIP",
            "Contrato social",
            "Certificado digital",
            "Senha de acesso a prefeitura",
            "Código de acesso ao Simples Nacional (se aplicável)",
            "Senha de acesso ao portal estadual/sefaz",
            "última NFS-e/NF-e emitida (PDF/XML)"
        ];

        const reformatted: DocumentFile[] = this.listDeps.flatMap(item =>
            item.types.map(type => {
                if (requiredDocuments.includes(type)) {

                    const obj = new DocumentFile();
                    obj.companyId = this.process?.company?.id ?? null;
                    obj.competence = null
                    obj.contentType = null
                    obj.date = null
                    obj.url = null
                    obj.expireDate = null
                    obj.name = null
                    obj.status = "ACTIVE"
                    obj.user = this.storageUtils.getLoggedUser();
                    obj.type = type;
                    obj.department = item.name
                    obj.typeUser = this.storageUtils.getLoggedUser().type
                    return obj;
                }
                else {
                    let deadline = new Date();
                    deadline.setDate(deadline.getDate() + 60);

                    const obj = new DocumentFile();
                    obj.companyId = this.process?.company?.id ?? null;
                    obj.competence = null
                    obj.contentType = null
                    obj.date = null
                    obj.url = null
                    obj.expireDate = null
                    obj.name = null
                    obj.status = "ACTIVE"
                    obj.user = this.storageUtils.getLoggedUser();
                    obj.type = type;
                    obj.department = item.name
                    return obj;
                }
            })
        );

        this.documentFileService.saveDefaultFile(reformatted, (response) => {
            if (response.success) {
                this.selectTable()
            }
        })
    }

    selectTable() {
        let typeUser = null;
        if (this.storageUtils.getLoggedUser().type === "CUSTOMER") {
            if (this.receivedWindow && (this.storageUtils.getLoggedUser().type === "CUSTOMER" || this.storageUtils.getLoggedUser().type === "CONTAZZ")) {
                typeUser = "CONTAZZ"

            } else {
                typeUser = "CUSTOMER"
            }
        } else {
            if (this.receivedWindow && (this.storageUtils.getLoggedUser().type === "CUSTOMER" || this.storageUtils.getLoggedUser().type === "CONTAZZ")) {
                typeUser = "CUSTOMER"
            } else {
                typeUser = "CONTAZZ"
            }
        }
        if (this.company == null) {
            this.company = new Company()
        }
        this.search.userId = this.process?.customer?.userId ?? this.storageUtils.getLoggedUser().id
        this.search.page = this.page.pageNumber
        this.search.companyId = null
        this.search.queryString = null

        this.search.typeUser = typeUser

        this.documentFileService.searchDefault(this.search, (result, list: any) => {
            if (list != null) {
                if (this.page.pageNumber) {
                    this.page.totalElements = list.totalAmount;
                    this.page.totalPages = list.pageQuantity;
                }
            }
            this.rows[this.page.pageNumber] = list.list;
            this.rowsPage = list.list;
            this.cdRef.detectChanges()
        });
    }

    nonOpting(row: any) {
        let user = this.storageUtils.getLoggedUser()
        user.info["opting"] = true
        this.userB.saveUserB(user, (result, list: any) => {
            if (result) {
                row.isFileSent = false
                this.documentFileService.save(row, result => {
                    this.selectTable()
                    this.cdRef.detectChanges()
                })
            }
        });
    }

    setPage(pageInfo) {
        this.page.pageNumber = pageInfo.offset + 1;
        if (this.rows[this.page.pageNumber]) {
            this.rowsPage = this.rows[this.page.pageNumber]
            this.selectTable();
        } else {
            this.selectTable();
        }
    }

    filterUpdate(event) {
        const val = event.target.value;
        this.search.page = 1;
        this.search.queryString = val;
        this.selectTable()
    }

    upload(row: any) {
        const modalRef = this.modalService.open(RegisterDocumentPageComponent);
        modalRef.componentInstance.company = this.company;
        modalRef.componentInstance.doc = row;
        modalRef.componentInstance.upload = true;
        modalRef.result.then((success) => {
            if (success != null) {
                this.selectTable()
                this.cdRef.detectChanges()
            }
        }).catch((error) => {
        });
    }

    detail(row: any) {
        const modalRef = this.modalService.open(RegisterDocumentPageComponent);
        modalRef.componentInstance.company = this.company;
        modalRef.componentInstance.doc = row;
        modalRef.result.then((success) => {
            if (success != null) {
                this.selectTable()
                this.cdRef.detectChanges()
            }
        }).catch((error) => {
        });
    }

    view(row: any) {
        window.open(row.url)
    }

    delete(row: any) {
        swal.fire({
            title: 'Atenção',
            text: 'Deseja realmente remover este documento?',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            icon: 'warning'
        }).then((result) => {
            if (result.value) {
                this.documentFileService.delete(row.id, result1 => {
                    this.loadDefautDocument()
                    swal.fire(
                        'Sucesso',
                        'Documento removido com sucesso',
                        'success'
                    );
                })
            }
        })
    }
}
